<template>
  <v-container fluid class="mt-6 mx-7">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <base-material-card inline icon="mdi-file-remove-outline" color="primary" class="ml-0 px-5 py-4">
        <template v-slot:after-heading>
          <div class="display-2 font-weight-light">
            {{ title }}
          </div>
        </template>
        <v-form v-if="!$route.params.id || vuexDataSetado" class="pt-5">
          <parametros ref="parametrosREF" />
          <v-row>
            <v-col />
            <v-col cols="12" md="6">
              <v-btn
                id="btn-save-simulador-baixas"
                class="mr-0 mt-5"
                style="float: right"
                color="success"
                min-width="100"
                :disabled="invalid"
                :loading="loading"
                @click="salvar()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>

<script>
  import SimulacaoBaixasService from '@/services/SimulacaoBaixasService';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      Parametros: () => import('@/components/simuladorBaixas/Parametros.vue')
    },
    mixins: [tourMixins],

    data: () => ({
      loading: false,
      vuexDataSetado: false,
      arrTour: [
        {
          element: '#titulo-simulacao-baixas',
          intro: 'Aqui você deve inserir um nome para sua simulação de baixas.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#simulacao-baixas-origem-ais',
          intro:
            'Aqui você deve selecionar a origem do AIS, caso seja <b>AIS ou Laudo Blindado</b>, selecione a Data Base, caso seja Arquivo, faça o upload em CSV e mapeie os campos requisitados.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#simulacao-baixas-v-alert',
          intro: 'Caso tenha dúvidas quanto ao arquivo de baixas, você pode baixar o arquivo modelo da simulação de baixas.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#simulacao-baixas-campos-arquivo',
          intro: 'Aqui você deve inserir o arquivo de baixas com os atributos da sua simulação.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#painel-rodadas',
          intro: 'Aqui você pode adicionar, remover e editar as rodadas da sua simulação de baixas.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#simulacao-baixas-somente-uar-principal',
          intro: 'Aqui você pode escolher se sua simulação considerará apenas UAR principal.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#simulacao-baixas-atributos-coringa',
          intro:
            'Aqui você pode escolher se sua simulação habilitará Atributos Coringa.<br>Caso habilitado, irá considerar atributos vazios ou iguais nas duas bases, caso contrário, apenas iguais em ambas as bases',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#simulacao-baixas-atributos-coringa-help',
          intro: 'Caso tenha dúvidas sobre os Atributos Coringa, clique aqui pode clicar aqui para maiores detalhes.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#btn-save-simulador-baixas',
          intro: 'Após seleção dos critérios anteriores clique aqui para salvar e executar sua simulação de baixas.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    }),

    computed: {
      title() {
        return this.$route.params.id ? `Editando Simulação de Baixas` : 'Adicionar Nova Simulação de Baixas';
      }
    },

    created() {
      this.$store.dispatch('clearSimulacaoBaixas');

      if (this.$route.params.id) {
        this.getById(this.$route.params.id);
      } else {
        this.iniciarTourPagina();
      }
    },

    methods: {
      getById(id) {
        SimulacaoBaixasService.getSimulacao(id)
          .then((response) => {
            this.setDataInVuex(response.data.simulacao);
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar simulação de baixas.', '', { position: 'topRight' });
          })
          .finally(() => this.iniciarTourPagina());
      },

      salvar() {
        const data = this.$refs.parametrosREF.exportData();
        this.loading = true;

        SimulacaoBaixasService.salvarSimulacao(data, data.id)
          .then(() => {
            this.$toast.success('Simulação de Baixas salva com sucesso.', '', { position: 'topRight' });
            this.$router.push({ name: 'Simulador de Baixas Histórico' });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao salvar simulação de baixas.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },

      setDataInVuex(item) {
        this.$store.dispatch('setSimulacaoBaixasRodadas', item.rodadas);

        if (item.origem_ais == 'ARQUIVO') {
          this.$store.dispatch('setSimulacaoBaixas', {
            arquivoAis: {
              id: item.arquivo_ais.id,
              delimitador: item.arquivo_ais_delimitador,
              involucro: item.arquivo_ais_involucro,
              escape: item.arquivo_ais_escape,
              mapeamento: item.mapeamento_arquivo_ais
            }
          });
        }

        this.$store.dispatch('setSimulacaoBaixas', {
          nome: item.nome,
          origemBase: item.origem_ais,
          dataBase: this.getOnlyDateIgnoringTimestamp(item.data_base),
          arquivoBaixas: {
            id: item.arquivo_id,
            fileObj: new File([''], item.arquivo.arquivo, { type: 'text/csv' }),
            delimitador: item.arquivo_delimitador,
            involucro: item.arquivo_involucro,
            escape: item.arquivo_escape,
            fakeFile: true,
            headerValido: true
          },
          somenteUarPrincipal: item.somente_uar_principal,
          atributosCoringa: item.atributos_coringa
        });

        this.vuexDataSetado = true;
        this.$forceUpdate();
      },

      getOnlyDateIgnoringTimestamp(date) {
        if (date && date.length > 10) {
          date = date.substr(0, 10);
        }

        return date;
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>